
define('text!templates/components/welcome_message/welcome_message.html',[],function () { return '<i class="fa fa-lightbulb-o fa-2x pull-left m-r-10"></i>\n<p class="pull-left"><%= message_body  %></p>\n<a href="#">\n    <i class="fa fa-times pull-right m-l-10" data-dismiss="alert"></i>\n</a>\n<div class="clearfix"></div>';});

